import { useState } from "react";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { useHardwareDesignFiles } from "../../hooks/useHardwareDesignFiles.ts";
import { useDecodeBinaryForDeveloper } from "../../hooks/useDecodeBinaryForDeveloper.ts";
import { useEncodeBinaryForDeveloper } from "../../hooks/useEncodeBinaryForDeveloper.ts";
import { useBinaryFileExtension } from "../../hooks/useBinaryFileExtension.ts";
import { useBinaryVersion } from "../../hooks/useBinaryVersion.ts";
import { frontendVersion } from "../../config/version.ts";
import PageLayout from "../../components/PageLayout.tsx";

const SECRET = "qde";

const DeveloperPage = () => {
  const [input, setInput] = useState("");
  const [unlocked, setUnlocked] = useState(false);
  const { getHardwareDesignFiles } = useHardwareDesignFiles();
  const { decode } = useDecodeBinaryForDeveloper();
  const { encode } = useEncodeBinaryForDeveloper();
  const { fileExtension } = useBinaryFileExtension();
  const { version } = useBinaryVersion();

  const getFilenameWithoutExtension = (filename: string): string => {
    return filename.replace(/\.[^/.]+$/, "");
  };

  const handleConvertToJson = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      const config = await decode(file);
      const blob = new Blob([JSON.stringify(config, null, 2)], {
        type: "application/json",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = getFilenameWithoutExtension(file.name) + ".json";
      link.click();
    } catch {
      alert("Fehler beim Dekodieren der Datei.");
    }
  };

  const handleConvertToBinary = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      const text = await file.text();
      const blob = await encode(text);
      if (!blob) return;
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download =
        new Date().toISOString().slice(0, 10).replace(/-/g, "") + "_" + fileExtension;
      link.click();
      URL.revokeObjectURL(url);
    } catch {
      alert("Fehler beim Dekodieren der Datei.");
    }
  };

  const handleUnlock = () => {
    if (input === SECRET) {
      setUnlocked(true);
    } else {
      alert("Falsches Passwort");
    }
  };

  if (!unlocked) {
    return (
      <Box p={2}>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid size={12}>
            <TextField
              label="Passwort"
              type="password"
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />
          </Grid>
          <Grid size={12}>
            <Button onClick={handleUnlock} variant="contained" sx={{ mt: 2 }}>
              Entsperren
            </Button>
          </Grid>
        </Grid>
      </Box>
    );
  }

  return (
    <PageLayout title="Entwickleroptionen">
      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Versionen
        </Typography>
        <Typography variant="body2">Frontend-Version: {frontendVersion}</Typography>
        <Typography variant="body2">Config-Version: {version || "lädt..."}</Typography>
      </Paper>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid size={12}>
          <Button variant="outlined" onClick={() => getHardwareDesignFiles()}>
            Hardware Design Files exportieren
          </Button>
        </Grid>
        <Grid size={12}>
          <Button variant="outlined" component="label">
            Konfiguration Binär → JSON
            <input
              hidden
              type="file"
              accept={fileExtension}
              onChange={handleConvertToJson}
            />
          </Button>
        </Grid>
        <Grid size={12}>
          <Button variant="outlined" component="label">
            Konfiguration JSON → Binär
            <input hidden type="file" accept={"json"} onChange={handleConvertToBinary} />
          </Button>
        </Grid>
      </Grid>
    </PageLayout>
  );
};

export default DeveloperPage;
